import { Button, Drawer, Form, message, Space } from "antd";
import {
  AiOutlineClose,
  AiOutlineFacebook,
  AiOutlineLinkedin,
} from "react-icons/ai";
import { FiTwitter } from "react-icons/fi";
import { IoLogoInstagram, IoSaveOutline } from "react-icons/io5";
import { useEffect, useState } from "react";
import { Input } from "@mantine/core";
import saveSocial from "../../../services/saveSocial";
export default function SocialsPannel({
  isVisible,
  setVisible,
  selected,
}: any) {
  const [twitter, setTwitter] = useState<any>(null);
  const [facebook, setFacebook] = useState<any>(null);
  const [linkedin, setLinkedin] = useState<any>(null);
  const [instagram, setInstagram] = useState<any>(null);
  const { _id } = selected;
  const customer_id = _id;
  useEffect(() => {}, [selected]);

  const onSubmit = async ({ data }: any) => {
    const response = await saveSocial(data, customer_id);
    if (response.success) {
      message.success("Updated successfully");
    } else {
      message.error("Something went wrong");
    }
  };

  return (
    <Drawer
      title={
        <div className="flex items-center">
          <span className="mr-2 text-lg">Customer Social Networks</span>
        </div>
      }
      placement="right"
      width={600}
      onClose={() => setVisible(!isVisible)}
      visible={isVisible}
      closable={false}
      extra={
        <Space>
          <Button
            type="default"
            color="#E50000"
            onClick={() => setVisible(!isVisible)}
            danger
          >
            <AiOutlineClose />
          </Button>
        </Space>
      }
    >
      <div className="">
        <div className="flex items-center mb-2 w-full ">
          <Input
            icon={<FiTwitter size={16} />}
            placeholder="Twitter"
            onChange={(e: any) => setTwitter(e.target.value)}
            rightSectionWidth={70}
            styles={{ rightSection: { pointerEvents: "painted" } }}
            className="flex-1"
          />
          <button
            onClick={() =>
              onSubmit({
                data: {
                  name: twitter,
                  link: `https://twitter.com/${twitter}`,
                  type: 1,
                  customer: _id,
                },
              })
            }
            className="border p-2 ml-2 rounded-sm hover:bg-green-100"
          >
            <IoSaveOutline size={16} />
          </button>
        </div>
        <div className="flex items-center mb-2">
          <Input
            icon={<AiOutlineFacebook size={16} />}
            placeholder="Facebook"
            rightSectionWidth={70}
            styles={{ rightSection: { pointerEvents: "painted" } }}
            className="flex-1"
          />
          <button className="border p-2 ml-2 rounded-sm hover:bg-green-100">
            <IoSaveOutline size={16} />
          </button>
        </div>
        <div className="flex items-center mb-2">
          <Input
            icon={<AiOutlineLinkedin size={16} />}
            placeholder="Linkedin"
            rightSectionWidth={70}
            styles={{ rightSection: { pointerEvents: "painted" } }}
            className="flex-1"
          />
          <button className="border p-2 ml-2 rounded-sm hover:bg-green-100">
            <IoSaveOutline size={16} />
          </button>
        </div>
        <div className="flex items-center mb-2">
          <Input
            icon={<IoLogoInstagram size={16} />}
            placeholder="Instagram"
            rightSectionWidth={70}
            styles={{ rightSection: { pointerEvents: "painted" } }}
            className="flex-1"
          />
          <button className="border p-2 ml-2 rounded-sm hover:bg-green-100">
            <IoSaveOutline size={16} />
          </button>
        </div>
      </div>
    </Drawer>
  );
}
